import { Link } from "react-router-dom";
import Header from "../components/Header/Header";
import PageBanner from "../components/about/PageBanner";
import Counter from "../components/Counter";
import Footer from "../components/Footer/Footer";
import { Fade } from "react-awesome-reveal";
import AboutCube from "../components/about/AboutCube";
import ImageMasonry from "../components/masonary/MasonaryAbout";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchTranslations } from "../actions/languageActions";
import NewHeader from "../components/Header/NewHeader";
import Loading from "../components/loading/Loading";
import FormModal from "../elements/FormModal";
import { Helmet } from "react-helmet-async";
import LogoSlider from "../components/LogoSlider";

const handleChnge = () => {
  onclick = "window.print()";
};

const IndustryPartners = () => {
  const dispatch = useDispatch();
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  const translations = useSelector((state) => state.language.translations[selectedLanguage]);

  useEffect(() => {
    dispatch(fetchTranslations(selectedLanguage));
  }, [dispatch, selectedLanguage]);

  // Handle Zoho SalesIQ lifecycle for this page only
  useEffect(() => {
    // 1. Initialize global $zoho object
    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || { ready: function () {} };

    // 2. Dynamically create and inject the script tag
    const scriptId = "zsiqscript";
    let script = document.getElementById(scriptId);

    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "https://salesiq.zohopublic.com.au/widget?wc=8f3652f154f4b9b4b4caf90f44a92524c555b8bd3c196ed488d8d454280b2a0f30ea8b0f463e4d0ad47d78a923021415";
      script.defer = true;
      document.body.appendChild(script);
    } else {
      // If script is already loaded (e.g. returning to this page), show widget
      if (window.$zoho && window.$zoho.salesiq && window.$zoho.salesiq.show) {
        window.$zoho.salesiq.show();
      }
    }

    // 3. Hide widget when navigating away from this component
    return () => {
      if (window.$zoho && window.$zoho.salesiq && window.$zoho.salesiq.hide) {
        window.$zoho.salesiq.hide();
      }
    };
  }, []);

  if (!translations) {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  const { aboutus } = translations;
  const industryList = aboutus.industry.list;
  const learnUs = aboutus.learnUs.list;

  return (
    <>
      <Helmet>
        <title>Industry Partners & Training Collaboration | Signet</title>
        <meta
          name="description"
          content="Partner with Signet Institute of Australia for skilled students, clinical placements and industry training. Build strong workforce partnerships today."
          data-rh="true"
        />
      </Helmet>
      <NewHeader />

      <div className="about-sec pt-100">
        <h3 className="text-center pt-60">Industry Partners Reviews</h3>
        <section className="nanhe container container--testimonials">
          <div className="testimonial">
            <p className="testimonial__text mb-25">
              "Amrit was a welcome addition to our nursing team, while fulfilling his clinical placement. I wish Amrit all the very best in his future endeavours."
            </p>
            <div className="testimonial__details">
              <div className="testimonial__info">
                <h4 className="testimonial__name">Ipswich Hospital </h4>
              </div>
            </div>
          </div>

          <div className="testimonial">
            <p className="testimonial__text mb-25">
              "Students were well prepared and keen for placement. Eager to learn and make the most of placement."
            </p>
            <div className="testimonial__details">
              <div className="testimonial__info">
                <h4 className="testimonial__name">LaTrobe Regional Hospital</h4>
              </div>
            </div>
          </div>

          <div className="testimonial">
            <p className="testimonial__text mb-25">
              "Students were well prepared and eager to learn. Asked for feedback on a regular basis. Were professional in dealings with both staff and patients. Asked questions when unsure. "
            </p>
            <div className="testimonial__details">
              <div className="testimonial__info">
                <h4 className="testimonial__name">LaTrobe Regional Hospital</h4>
              </div>
            </div>
          </div>

          <div className="testimonial">
            <p className="testimonial__text mb-25">
              “Jasmine was well supported by Signet through-out placement. If any issues Signet was very easy to contact.”
            </p>
            <div className="testimonial__details">
              <div className="testimonial__info">
                <h4 className="testimonial__name">LaTrobe Regional Hospital</h4>
              </div>
            </div>
          </div>

          <div className="testimonial">
            <p className="testimonial__text mb-25">
              “Students were generally well prepared. Probably weren’t expecting the number of abbreviations used including on handover sheet”
            </p>
            <div className="testimonial__details">
              <div className="testimonial__info">
                <h4 className="testimonial__name">Southwest Healthcare</h4>
              </div>
            </div>
          </div>

          <div className="testimonial">
            <p className="testimonial__text mb-25">
              “Amit was a pleasure to have, He was a very willing participant and will go far in his career”
            </p>
            <div className="testimonial__details">
              <div className="testimonial__info">
                <h4 className="testimonial__name">Specialist SurgiCentre</h4>
              </div>
            </div>
          </div>

          <div className="testimonial">
            <p className="testimonial__text mb-25">
              “This was a very successful placement. The student was excellent and we have offered employment which has been accepted. The team at Signet are really easy to deal with and we look forward to continuing this relationship”
            </p>
            <div className="testimonial__details">
              <div className="testimonial__info">
                <h4 className="testimonial__name">Victoria Parade Day Hospital</h4>
              </div>
            </div>
          </div>

          <div className="testimonial">
            <p className="testimonial__text mb-25">
              “Brian is a great student, who was eager and keen to learn. He has a very respectful and friendly manner and is having a very successful placement. The team at Signet provide great communication ad easy to work with -thanks”
            </p>
            <div className="testimonial__details">
              <div className="testimonial__info">
                <h4 className="testimonial__name">Victoria Parade Day Hospital</h4>
              </div>
            </div>
          </div>

          <div className="testimonial">
            <p className="testimonial__text mb-25">
              “A very confident and capable student. Demonstrated an eagerness to learn and really embraced the clinical placement. Interaction with our team and patients was above average. Yiting would be a great asset to any team. Has a desire to go into mental health and continue her studies. I wish her well. Another great placement by Signet @ VPSC. Thanks to your team”
            </p>
            <div className="testimonial__details">
              <div className="testimonial__info">
                <h4 className="testimonial__name">Victoria Parade Day Hospital</h4>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="container pt-60">
        <div className="row">
          <div className="col-md-12 text-center">
            <h1>Building Strong Industry Partnerships</h1>
          </div>
          <div className="row pt-30">
            <LogoSlider />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default IndustryPartners;